import { Component, Prop, Vue } from "vue-property-decorator";
import { ImageInputModuleModel, ImageInputModuleOption, ConfiguratorValueUpdateModel, configuratorConstants } from "../models";
import { productConfiguratorStore as configuratorstore } from "../store";
import { EventBus } from "../../../events";

@Component
export default class ImageInputModule extends Vue {
    protected selectedOption: ImageInputModuleOption<any> = {} as ImageInputModuleOption<any>;
    protected imageClass: string = "selector__item image small-4";
    protected isMobile: boolean = false;

    @Prop()
    protected vm!: ImageInputModuleModel<any>;

    @Prop()
    protected autoSelect!: boolean;

    protected created() {
        if (this.vm.options && this.vm.options.length && this.autoSelect) {
            this.selectedOption = this.vm.options[0];
            this.onSelectedChange();
        }

        if (this.vm.options && this.vm.options.length) {
            const preselectedOption = this.vm.options.find(x => x.preSelected);
            if (preselectedOption) {
                this.selectedOption = preselectedOption;
                this.onSelectedChange();
            }
        }

        if (this.vm.desktopNumberOfImageOptions === 1) {
            this.imageClass = this.imageClass + " desktop-image-1";
        } else if (this.vm.desktopNumberOfImageOptions === 2) {
            this.imageClass = this.imageClass + " desktop-image-2";
        }

        if (this.vm.mobileNumberOfImageOptions === 1) {
            this.imageClass = this.imageClass + " mobile-image-1";
        } else if (this.vm.mobileNumberOfImageOptions === 2) {
            this.imageClass = this.imageClass + " mobile-image-2";
        }
        this.isMobile = window.innerWidth < 640;
    }

    protected mounted() {
        EventBus.$on("updategroundshape", () => {
            const updatedValueOption = configuratorstore.configuratorValues.find(a => a.property.propertyName === configuratorConstants.GroundShape);
            if (updatedValueOption) {
                this.selectedOption = updatedValueOption.value;
            }
        });
    }

    protected onSelectedChange(setCookie: boolean = false) {
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedOption.value, valueDescriptions: [{ title: "", text: this.selectedOption.title }],
         propertyName: this.vm.configuratorProperties[0].propertyName, isText: false, resetClimateSavingsCookie: this.vm.resetClimateSavingsCookie };
        this.$emit("update-configurator-value", updateModel, setCookie);
    }
}
